module.exports = __webpack_public_path__ + "img/logo.4dbd7bd0.svg";